export default "__VITE_ASSET__CmmW9Rz1__"